function getScreenResolution(documentServices) {
  return documentServices.env.screen.getResolution()
}

export default {
  screen: {
    getScreenResolution,
  },
}
